import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAuthMenu } from '../../models';
import { Subject } from 'rxjs';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AuthorizationService } from '../../services';
import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-menu-horizontal',
  standalone: true,
  imports: [NgTemplateOutlet, NgFor, NgIf, NgClass, RouterLink, NgbDropdownModule],
  templateUrl: './menu-horizontal.component.html',
  styleUrl: './menu-horizontal.component.scss'
})
export class MenuHorizontalComponent {

  /*-------------------------- input parameters ------------*/

  @Input() menuItems: IAuthMenu[] = [];

  @Output() onExportClicked = new EventEmitter<string>();

  //----------------- data properties  ------------------

  //menuItems!: IAuthMenu[];
  currExpandedItem!: IAuthMenu;
  baseExpandedItem!: IAuthMenu;
  isDropdownOpen: boolean = false;
  isExportEnabled: boolean = false;


  //----------------- State properties  ------------------

  protected destroy$ = new Subject();
  protected prevImpersonationEmail?: string | null;


  //----------------- Constructor  ------------------
  constructor(private router: Router
    , private authService: AuthorizationService) {

  }

  ngOnInit(): void {

    this.refreshSelection(this.menuItems, this.router.url);
    //console.log(this.menuItems);

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.refreshSelection(this.menuItems, event.url);
          //console.log(this.menuItems);
        }
      });

  }

  menuenter($event: Event) {
    const targetElement = $event.target as HTMLElement;
    let parentElement: HTMLElement | null = null;
    if (targetElement.classList.contains('dropdown')) {
      parentElement = targetElement;
    }
    else {
      parentElement = targetElement.parentElement;
    }

    if (parentElement) {
      var subMenuUl = parentElement.querySelector('.submenu') as HTMLElement;
      if (subMenuUl) {
        if (!subMenuUl.classList.contains('show')) {
          subMenuUl.classList.add('show');
        }
      }
    }
  }

  menuleave($event: Event) {
    const targetElement = $event.target as HTMLElement;
    if (targetElement) {
      var subMenuUl = targetElement.querySelector('.submenu') as HTMLElement;
      if (subMenuUl) {
        if (subMenuUl.classList.contains('show')) {
          subMenuUl.classList.remove('show');
        }
      }
    }
  }

  refreshSelection(items: IAuthMenu[], newUrl: string): boolean {

    if (!items)
      return false;

    let anySelected = false;

    for (let item of items) {

      if (item.hasChildren && item.children) {
        item.selected = this.refreshSelection(item.children, newUrl);
      }
      else {
        item.selected = !!(item.url && newUrl && newUrl.includes(item.url));
      }

      if (item.selected)
        anySelected = true;
    }

    return anySelected;
  }

  //----------------- Control processing   ------------------

  assignLevel(item: IAuthMenu, level: number): number {

    // level is automatically generated by the templates - we keep a record here back to the item so we can implement additional features i.e. accordion at level 2
    item.level = level;

    return level;
  }

  isBookmark(item: IAuthMenu): boolean {
    if (item.url && item.url.length > 0)
      return item.url.includes("#");

    return false;
  }

  getImageClass(item: IAuthMenu): string {
    if (!item)
      return "";

    if (item.cssClass && item.cssClass.length > 0)
      return "isg-mitem-image " + item.cssClass;

    return "";
  }

  exportClick(item: IAuthMenu): void {
    if (item.target && item.target != null && this.isExportEnabled) {
      this.onExportClicked.emit(item.target);
    }
  }

  /*export(item)*/

  getLinkTitle(item: IAuthMenu): string {
    if (item.target && item.target != null) {
      if (item.target?.indexOf("_ppt")>=0) {
        return "Export as PPT";
      }
      if (item.target?.indexOf("_pdf")>=0) {
        return "Export as PDF";
      }
    }

    return "Export";
  }

  getExportLogo(item: IAuthMenu): string {
    if (item.target && item.target != null) {
      if (item.target?.indexOf("_ppt")>=0) {
        return "fa-file-powerpoint";
      }
      if (item.target?.indexOf("_pdf")>=0) {
        return "fa-file-pdf";
      }
    }

    return "fa-file";
  }

  isItemRouteInternal(url: string): boolean {

    if (url.startsWith("http"))
      return false;
    else
      return true;
  }

  isExportButton(item: IAuthMenu): boolean {
    if (item.target && item.target != null) {
      if (item.target?.indexOf("_ppt") >= 0 || item.target?.indexOf("_pdf") >= 0) {
        this.isExportEnabled = true;
        return true;
      }
    }

    return false;
  }

  toggleSubmenu(ev: Event, item: IAuthMenu) {
    if (item) {

      var isExpanding: boolean = !(item.expanded);

      // Remove styling for the previous last expanded item
      if (this.currExpandedItem && isExpanding) {
        this.currExpandedItem.currExpanded = false;
      }

      // Create an accordion type behaviour for level 2 that only 1 item can be expanded at a time to reduce visual overload
      if (isExpanding && item.level == 2 && this.baseExpandedItem)
        this.baseExpandedItem.expanded = false;

      item.expanded = isExpanding;
      item.currExpanded = isExpanding;


      if (isExpanding) {
        // if expanding make this item the most recent expanded item
        this.currExpandedItem = item;

        // if level 2 then record so that we can implement our accordion implementation
        if (item.level == 2)
          this.baseExpandedItem = item;
      }
    }

    // do not propagate the expansion/collapse
    ev.preventDefault();
  }
}
